import React from "react";
import Folder from "../Folder";
import { locale } from "../../utils/LocaleManager";
import LabelText from "../LabelText";
import { black, mainFont } from "../../utils/StyleHelpers";

const ScreenFolderContainer = ({
  isClickedFolder,
  setIsClickedFolder,
}: any) => {
  return (
    <>
      <LabelText
        text={locale.folders}
        style={{
          fontFamily: mainFont,
          fontWeight: 600,
          fontSize: "1.25rem",
          lineHeight: "1.5rem",
          color: black,
        }}
      />
      <Folder
        isClickedFolder={isClickedFolder}
        setIsClickedFolder={setIsClickedFolder}
      />
    </>
  );
};

export default ScreenFolderContainer;
